



























































import { defineComponent, onBeforeUnmount, onMounted, ref, useFetch } from '@nuxtjs/composition-api'
import { useApi } from '~/composables';
import { Logger } from '~/helpers/logger';
import { GET_HOT_TOPICS } from '~/modules/catalog/category/queries/solepro/gotTopics.gql';
import { usePageStore } from '~/stores/page';
import { temiCaldiLink, hotTopicsPageView } from '~/helpers/trackings/24orepro/pages';

export default defineComponent({
    head() {
        return {
            title: 'Temi Caldi'
        }
    },
    setup() {
        const { query } = useApi();
        const { routeData } = usePageStore();
        const topics = ref([])
        const title = ref('Temi Caldi')
        const description = ref()
        const trackTemiCaldiLink = async (link) => {
            await temiCaldiLink();
            location.href = link;
        }

        useFetch(async () => {
            const { data } = await query(GET_HOT_TOPICS, { hotTopicsUid: routeData.uid });
            try {
                const hotTopics = data['categories'].items[0];
                topics.value = hotTopics.children
                title.value = hotTopics.name
                description.value = hotTopics.description
            } catch (e) {
                Logger.warn('HotTopicsPage - no hot topics found')
            }

            await hotTopicsPageView()
        })
        onMounted(()=>{
            document.getElementById('mainContent').classList.add('bg-pattern') 
            document.getElementById('mainContent').classList.add('bg-pattern--dots-grey') 
        }),
        onBeforeUnmount(()=>{
            document.getElementById('mainContent').classList.remove('bg-pattern') 
            document.getElementById('mainContent').classList.remove('bg-pattern--dots-grey') 
        })
        return {
            trackTemiCaldiLink,
            title,
            description,
            topics
        }
    },
})
